module.exports = __webpack_public_path__ + "static/media/Resume_C.Sachs.c56d63e9.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Resume_C.Sachs.pdf
// module id = 305
// module chunks = 0